import React from 'react';

type StatusType = 'submitted' | 'pending' | 'draft' | 'verified' | 'awarded' | 'active' | 'inactive';

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
}

const statusConfig: Record<StatusType, { className: string; dot: string; defaultLabel: string }> = {
  submitted: {
    className: 'bg-[var(--success-bg)] text-[var(--success)]',
    dot: 'bg-[var(--success)]',
    defaultLabel: 'Submitted',
  },
  pending: {
    className: 'bg-[var(--warning-bg)] text-[var(--warning)]',
    dot: 'bg-[var(--warning)]',
    defaultLabel: 'Pending',
  },
  draft: {
    className: 'bg-muted text-muted-foreground',
    dot: 'bg-muted-foreground',
    defaultLabel: 'Draft',
  },
  verified: {
    className: 'bg-[var(--info-bg)] text-[var(--info)]',
    dot: 'bg-[var(--info)]',
    defaultLabel: 'Verified',
  },
  awarded: {
    className: 'bg-amber-50 text-amber-700',
    dot: 'bg-amber-500',
    defaultLabel: 'Awarded',
  },
  active: {
    className: 'bg-[var(--success-bg)] text-[var(--success)]',
    dot: 'bg-[var(--success)]',
    defaultLabel: 'Active',
  },
  inactive: {
    className: 'bg-muted text-muted-foreground',
    dot: 'bg-muted-foreground',
    defaultLabel: 'Inactive',
  },
};

export default function StatusBadge({ status, label }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${config.className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} />
      {label ?? config.defaultLabel}
    </span>
  );
}